export default [
    {
        path: '/',
        name: 'list',
        component: () => import('@/views/SslList/SslList'),
    },
    {
        path: '/:id',
        name: 'detail',
        component: () => import('@/views/SslDetail/SslDetail'),
    },
    {
        path: '/:id/active',
        name: 'active',
        component: () => import('@/views/SslActive/SslActive'),
    },
    {
        path: '/:id/reissue',
        name: 'reissue',
        component: () => import('@/views/SslReissue/SslReissue'),
    },
    {
        path: '/:id/edit-dcv',
        name: 'edit-dcv',
        component: () => import('@/views/SslEditDcv/SslEditDcv'),
    },
];
